module.exports = __webpack_public_path__ + "assets/img/newQuestiongoldmedal@2x.251593f7.png";